export const environment = {
	production: true,
	apiUrl: 'https://saruman.shadowfax.in/web_app/',
	api_server: 'https://saruman.shadowfax.in/',
	apiUrl2 :'https://figwit.shadowfax.in/',
	connectUrl :'https://connectk8s.shadowfax.in/',
	paymentApiUrl: 'https://saruman.shadowfax.in/',
	staticUrl: 'https://tracker.shadowfax.in/',
	sfxWebsiteBackend:'https://website-backend.shadowfax.in/',
	rzp:{
		'pgKey': 'rzp_live_jgfgetfzG9ZEYI',
		'pgName': 'Shadowfax',
		'pgTheme': '#F37254',
	},
	analytics: true,
	icons:'/',
	mapTilerKey: 'Coc9mXWcLmvGHxKIoIyo',
	sfxTrackStaticToken: 'cePcVR7z7FIETB4PxguHC2YJGk6NncHnByrJttgRIUqNxfWezuzAUvtALyqcHJEC'
};